/**
 * File: home.js.
 *
 * Import and initialize functions that are needed for homepage only
 */

export default {
  init() {
    this.render();
  },
  render() {

  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
